import React, { useEffect, useState } from "react";
import OrganizationManagerHeader from "src/components/organization-manager-header";
import store from "src/store";
import RefreshIcon from "@material-ui/icons/Refresh";
import Progress from "src/components/progress";
import OrganizationCard from "src/components/organization-card";
import useIsLoggedIn from "src/utils/use-is-logged-in";

export default function OrganizationManager() {
    const { isLoggedIn } = useIsLoggedIn();

    const [loading, setLoading] = useState(true);


    const getOrganizationList = async () => {
        setLoading(true);
        await store.fetchOrganizations();
        setLoading(false);
    };

    useEffect(() => { if (store.isAdmin) { getOrganizationList() } }, [store.isAdmin]);

    const getOrganizationError = () => {
        if (store.organizations === undefined || !Array.isArray(store.organizations)) {
            return 'Unable to fetch organizations';
        } else {
            return 'No organizations found';
        }
    }

    const refreshOrganizations = async () => {
        setLoading(true);
        await store.updateOrganizationList();
        setLoading(false);
    }

    store.useRerenderIfChange(() => [store.organizations, store.isAdmin]);

    return (
        <> {
            (isLoggedIn && store.isAdmin) ?
                <div css={`
                        padding:35px;
                        background:#F6F6FA;
                        min-height:100vh;
                    `}>
                    <div>
                        <OrganizationManagerHeader />
                    </div>
                    <hr css={`
                        margin-top:15px;
                        border: 1px solid #EAEAF2;
                        `}
                    />
                    <div css={`
                            margin-bottom:100px;
                        `}>
                        {
                            (!loading && store.organizations?.length) ?
                                <div title="Refresh" css="margin-top: 10px;display:inline-block;flex-grow:1">
                                    <div
                                        css={`cursor:pointer;display:flex; align-items: center; flex-direction: row; width: max-content; position:relative; bottom: 5px`}
                                        title="Refresh"
                                        onClick={() => {
                                            refreshOrganizations();
                                        }}
                                    >
                                        <RefreshIcon style={{ color: '#000' }} />
                                        <div css={`width: max-content`}>Refresh</div>
                                    </div>
                                </div> : null
                        }

                        {loading && <Progress />}

                        {!loading && <div>
                            {
                                store.organizations?.length ?
                                    store.organizations?.map((item, index) =>
                                        <OrganizationCard key={index} organization={item} />
                                    )
                                    : getOrganizationError()
                            }
                        </div>}
                    </div >
                </div> :
                <div css={`
                    padding:35px;
                    background:#F6F6FA;
                    min-height:100vh;
                `}>
                    <h2 css="color: red;">Access denied!</h2>
                </div>
        }
        </>
    )
}